import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient } from "./ApiClient";
import { ICreateEmergencyTreatmentReport, IEmergencyTreatmentReport, ISaveEmergencyTreatmentReportModel, IEmergencyTreatmentsModel } from "../models/IEmergencyTreatment";
import { ISaveTreatment, IPatientTreatment } from "../models/IPatientTreatment";


export class EmergencyTreatmentApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }

    getEmergencyTreatmentReport(emergencyTreatmentId: string, refresh: boolean, success: (data: IEmergencyTreatmentReport) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IEmergencyTreatmentReport>(`${Utils.LIB_API_BASE_URL}/emergencyTreatments/${emergencyTreatmentId}?refresh=${refresh}`, success, error, final)
    }

    createEmergencyTreatmentReport(formData: ICreateEmergencyTreatmentReport, success: (createdId: number) => void, error?: (message: string) => void, final?: () => void) {
        this.postWithResponse<number>(`${Utils.LIB_API_BASE_URL}/emergencyTreatments`, formData, success, error, final)
    }

    saveEmergencyTreatmentReport(formData: ISaveEmergencyTreatmentReportModel, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/emergencyTreatments/${formData.id}`, formData, success, error, final)
    }

    registerEmergencyTreatmentReport(formData: ISaveEmergencyTreatmentReportModel, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/emergencyTreatments/${formData.id}/register`, formData, success, error, final)
    }

    deleteEmergencyTreatmentReport(emergencyTreatmentReportId: number, success: () => void, error?: (message: string) => void, final?: () => void) {

        this.delete(`${Utils.LIB_API_BASE_URL}/emergencyTreatments/delete/${emergencyTreatmentReportId}`, success, error, final);
    }

    getValidTreatmentCodes(id: number, success: (data: IPatientTreatment[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IPatientTreatment[]>(`${Utils.LIB_API_BASE_URL}/emergencyTreatments/${id}/validTreatments`, success, error, final)
    }

    addEmergencyTreatment(id: number, treatment: ISaveTreatment, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/emergencyTreatments/${id}/treatments`, treatment, success, error, final);
    }

    getEmergencyTreatments(id: number, success: (data: IEmergencyTreatmentsModel) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IEmergencyTreatmentsModel>(`${Utils.LIB_API_BASE_URL}/emergencyTreatments/${id}/treatments`, success, error, final)
    }

    deleteEmergencyTreatment(patientTreatmentId: number, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.delete(`${Utils.LIB_API_BASE_URL}/emergencyTreatments/treatments/${patientTreatmentId}`, success, error, final);
    }

    creditTreatment(patientTreatmentId: number, success: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/emergencyTreatments/creditTreatment/${patientTreatmentId}`, undefined, success);
    }
}